// src/utils/getNestedValue.ts

export function getNestedValue(obj: any, path: string): any {
  return path.split(".").reduce((acc, part) => {
    if (acc && acc[part] !== undefined && acc[part] !== null) {
      return acc[part];
    }
    return "";
  }, obj);
}
